import React, { useEffect, useState } from "react";
import Api from "@api";
import ProgressiveImage from "@atom/ProgressiveImage";
import Loading from "@atom/Loading";
import Footer from "@molecule/Footer";
import style from "./style.scss";
import cn from "classnames";

export default ({ menu, footer }) => {
  const [data, setData] = useState();

  useEffect(() => {
    Api.getFeatured().then((e) => setData(e.blendguide));
  }, []);

  return data ? (
    <>
      <ProgressiveImage {...data} className={cn(style.blendguideimg)} />
      <Footer {...footer} navi={menu} />
    </>
  ) : (
    <Loading />
  );
};
